module.exports = __webpack_public_path__ + "img/aball1_lit.3797284c.png";